module.exports = __webpack_public_path__ + "static/img/3.8bd998f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/eng/3.png
// module id = DhRz
// module chunks = 0